// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
var initialState = {};
export var auditableBallotsSlice = createSlice({
    name: "auditableBallots",
    initialState: initialState,
    reducers: {
        setAuditableBallot: function (state, action) {
            state[action.payload.electionId] = {
                auditableBallot: action.payload.auditableBallot,
                isBlankBallot: action.payload.isBlankBallot,
            };
            return state;
        },
    },
});
export var setAuditableBallot = auditableBallotsSlice.actions.setAuditableBallot;
export var selectAuditableBallot = function (electionId) { return function (state) { var _a; return (_a = state.auditableBallots[electionId]) === null || _a === void 0 ? void 0 : _a.auditableBallot; }; };
export var selectIsBlankBallot = function (electionId) { return function (state) { var _a, _b; return (_b = (_a = state.auditableBallots[electionId]) === null || _a === void 0 ? void 0 : _a.isBlankBallot) !== null && _b !== void 0 ? _b : false; }; };
export default auditableBallotsSlice.reducer;
